import { render, staticRenderFns } from "./groups-of-concepts-grid.vue?vue&type=template&id=1875cd74&"
import script from "./groups-of-concepts-grid.ts?vue&type=script&lang=ts&"
export * from "./groups-of-concepts-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports